import { Link } from 'react-router-dom';

export default function CTASubmodalidades() {
  const handlePrint = () => {
    window.print();
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Continue Sua Jornada de Transformação
          </h2>
          <p className="text-lg text-gray-600">
            Explore outras técnicas poderosas de PNL
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <Link
            to="/worksheet-swish"
            className="group bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-2xl hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-purple-200"
          >
            <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <i className="ri-flashlight-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Técnica Swish</h3>
            <p className="text-sm text-gray-600 mb-4">
              Substitua padrões mentais indesejados rapidamente
            </p>
            <span className="text-purple-600 font-semibold text-sm flex items-center gap-2">
              Praticar agora
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </span>
          </Link>

          <Link
            to="/worksheet-encantations"
            className="group bg-gradient-to-br from-orange-50 to-red-50 p-6 rounded-2xl hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-orange-200"
          >
            <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <i className="ri-fire-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Ancoragem Emocional</h3>
            <p className="text-sm text-gray-600 mb-4">
              Crie gatilhos instantâneos para estados positivos
            </p>
            <span className="text-orange-600 font-semibold text-sm flex items-center gap-2">
              Praticar agora
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </span>
          </Link>

          <Link
            to="/worksheet-ressignificacao"
            className="group bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-2xl hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-blue-200"
          >
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <i className="ri-refresh-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Ressignificação</h3>
            <p className="text-sm text-gray-600 mb-4">
              Transforme o significado de experiências limitantes
            </p>
            <span className="text-blue-600 font-semibold text-sm flex items-center gap-2">
              Praticar agora
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </span>
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/planos#exercicios-pnl"
            className="px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-brain-line text-xl"></i>
            Ver Todos os Exercícios de PNL
          </Link>

          <button
            onClick={handlePrint}
            className="px-8 py-4 bg-white text-indigo-600 rounded-full font-semibold hover:shadow-lg transition-all duration-300 border-2 border-indigo-200 whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-printer-line text-xl"></i>
            Imprimir Worksheet
          </button>
        </div>
      </div>
    </section>
  );
}